import { useState, useEffect, useCallback } from 'react';
import api from '../services/apiService';

const usePendingHobbs = (currentUser) => {
  const [pendingRecord, setPendingRecord] = useState(null);

  const check = useCallback(async () => {
    if (!currentUser || currentUser.role !== 'pilot') return [];
    try {
      const res = await api.get('/api/aircraft/hobbs/pending');
      const pending = res.data?.pending || [];
      setPendingRecord(pending.length > 0 ? pending[0] : null);
      return pending;
    } catch (_) { return []; }
  }, [currentUser]);

  // Chequear al montar
  useEffect(() => { check(); }, [check]);

  // Escuchar push notification clickeada
  useEffect(() => {
    const handler = (event) => {
      if (event.data?.type === 'hobbs_final') check();
    };
    navigator.serviceWorker?.addEventListener('message', handler);
    return () => navigator.serviceWorker?.removeEventListener('message', handler);
  }, [check]);

  const dismiss  = () => setPendingRecord(null);
  const complete = () => { setPendingRecord(null); check(); };
  const recheck  = () => check();

  return { pendingRecord, dismiss, complete, recheck };
};

export default usePendingHobbs;
